import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavigationError, RedirectCommand, Router } from '@angular/router';

import { HttpStatusCode } from '@models';

export const redirectOutageNavigationErrors = (
  navigationError: NavigationError
) =>
  navigationError.error instanceof HttpErrorResponse &&
  navigationError.error.status === HttpStatusCode.SERVICE_UNAVAILABLE
    ? new RedirectCommand(inject(Router).parseUrl('/503'))
    : undefined;
